<div class="questionnaire-tag-layout">
  <div *ngFor="let item of questionnaireTagArray;let i = index" class="questionnaire-tag-elem elem-{{i}}" (click)="selectTag(i)">{{item.description}}</div>
</div>



// WEBPACK FOOTER //
// ./src/app/app-questionnaire/questionnaire-tag/questionnaire-tag.component.html